import { render, staticRenderFns } from "./FileMultipleUpload.vue?vue&type=template&id=879ac4cc&"
import script from "./FileMultipleUpload.vue?vue&type=script&lang=js&"
export * from "./FileMultipleUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports